import request from '@/utils/request'

//const serverURL = "https://vab-unicloud-3a9da9.service.tcloudbase.com";
//const apiURL = "/notice/getList";

// 获取所有订单列表
export function getOrderList(params) {
  return request({
    url: '/order/findList',
    method: 'get',
    params,
  })
}

// 获取商品订单列表
export function getProductOrders(params) {
  return request({
    url: '/product/findOrderList',
    method: 'get',
    params,
  })
}

// 获取商品订单详情
export function getProductOrder(params) {
  return request({
    url: '/product/findOrder',
    method: 'get',
    params,
  })
}

// 商品订单核销
export function verifyProductOrder(data) {
  return request({
    url: '/product/finishOrder',
    method: 'post',
    data,
  })
}

// 商品订单退款
export function refundProductOrder(data) {
  return request({
    url: '/product/refundOrder',
    method: 'post',
    data,
  })
}

// 商品订单批量退款
export function batchRefundProductOrder(data) {
  return request({
    url: '/product/batchRefundOrder',
    method: 'post',
    data,
  })
}

// 商品订单发货
export function shipProductOrder(data) {
  return request({
    url: '/product/shipOrder',
    method: 'post',
    data,
  })
}
//更新物流
export function updateOrder(data) {
  return request({
    url: '/product/updateOrder',
    method: 'post',
    data,
  })
}
//导出订单
// 导出商品订单：get product/exportOrder,参数：
// keyword // 订单标题、订单号
// periodMode // 1:按下单，2：按支付
// startDate // 开始日期
// endDate // 结束日期
// step // 订单状态
export function exportOrder(params) {
  return request({
    url: '/product/exportOrder',
    method: 'get',
    params,
  })
}


// 公寓相关
// 获取订单列表
export function getApartmentOrders(params) {
  return request({
    url: '/apartment/findOrderList',
    method: 'get',
    params,
  })
}
// 获取单个订单
export function getApartmentOrder(params) {
  return request({
    url: '/apartment/findOrder',
    method: 'get',
    params,
  })
}
// 删除订单
export function delApartmentOrder(data) {
  return request({
    url: '/apartment/removeOrder',
    method: 'post',
    data,
  })
}
// 订单退款
export function refundApartmentOrder(data) {
  return request({
    url: '/apartment/refundOrder',
    method: 'post',
    data,
  })
}
// 核销订单
export function verifyApartmentOrder(data) {
  return request({
    url: '/apartment/finishOrder',
    method: 'post',
    data,
  })
}
// 更新订单
export function updateApartmentOrder(data) {
  return request({
    url: '/apartment/updateOrder',
    method: 'post',
    data,
  })
}
// 取消订单
export function cancelApartmentOrder(data) {
  return request({
    url: '/apartment/cancelOrder',
    method: 'post',
    data,
  })
}
